/*=============================================== Accordion ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*==================== Imports ====================*/
import React, { useState } from "react";
import styled, { css } from "styled-components";
import { v4 as uuid } from "uuid";
import Variables from "./Variables";
import { P } from "./Font";
import Mixins from "./Mixins";
import FajnyIcon from "./FajnyIcon";
/*==================== Styles ====================*/
var Icon = styled(FajnyIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var Container = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: relative;\n    ", ";\n\n    ", "\n"], ["\n    position: relative;\n    ", ";\n\n    ", "\n"])), function (_a) {
    var $accordionStyle = _a.$accordionStyle;
    return Mixins.Grid({
        $gap: $accordionStyle === "rounded" ? 0 : "xxs",
    });
}, function (_a) {
    var $accordionStyle = _a.$accordionStyle;
    return $accordionStyle === "rounded" && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            border-radius: ", ";\n            overflow: hidden;\n            border: 1px solid ", ";\n            gap: 0;\n        "], ["\n            border-radius: ", ";\n            overflow: hidden;\n            border: 1px solid ", ";\n            gap: 0;\n        "])), Variables.Radiuses.M, Variables.Colors.Gray200);
});
var Item = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
var Content = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    max-height: ", ";\n    overflow: hidden;\n    transition: ", ";\n\n    ", "\n"], ["\n    max-height: ", ";\n    overflow: hidden;\n    transition: ", ";\n\n    ", "\n"])), function (_a) {
    var $isOpen = _a.$isOpen;
    return ($isOpen ? "600px" : 0);
}, Variables.Transitions.Long, function (_a) {
    var $accordionStyle = _a.$accordionStyle, $isOpen = _a.$isOpen;
    return $accordionStyle === "rounded"
        ? css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n                  padding: ", ";\n              "], ["\n                  padding: ", ";\n              "])), $isOpen ? Variables.Spacers.S : "0 ".concat(Variables.Spacers.S)) : css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n                  padding: ", ";\n              "], ["\n                  padding: ", ";\n              "])), $isOpen ? "".concat(Variables.Spacers.XS, " 0") : 0);
});
var Button = styled.button(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    width: 100%;\n    ", ";\n    padding: ", ";\n    border: none;\n    border-bottom: 1px solid\n        ", ";\n    background-color: ", ";\n    padding-bottom: ", ";\n    color: ", ";\n    height: ", ";\n\n    ", "\n\n    ", " {\n        transition: ", ";\n\n        ", "\n    }\n"], ["\n    width: 100%;\n    ", ";\n    padding: ", ";\n    border: none;\n    border-bottom: 1px solid\n        ", ";\n    background-color: ", ";\n    padding-bottom: ", ";\n    color: ", ";\n    height: ", ";\n\n    ", "\n\n    ", " {\n        transition: ", ";\n\n        ", "\n    }\n"
    /*==================== Component ====================*/
])), Mixins.Flexbox({
    $align: "center",
    $justify: "space-between",
}), function (_a) {
    var $accordionStyle = _a.$accordionStyle;
    return ($accordionStyle === "rounded" ? Variables.Spacers.S : 0);
}, function (_a) {
    var $accordionStyle = _a.$accordionStyle;
    return ($accordionStyle === "rounded" ? Variables.Colors.White : Variables.Colors.Gray200);
}, function (_a) {
    var $accordionStyle = _a.$accordionStyle;
    return $accordionStyle === "rounded" ? Variables.Colors.Primary500 : "transparent";
}, function (_a) {
    var $accordionStyle = _a.$accordionStyle;
    return $accordionStyle === "basic" && Variables.Spacers.XXS;
}, function (_a) {
    var $accordionStyle = _a.$accordionStyle;
    return $accordionStyle === "rounded" ? Variables.Colors.White : Variables.Colors.Primary500;
}, function (_a) {
    var $accordionStyle = _a.$accordionStyle;
    return ($accordionStyle === "rounded" ? "49px" : "29px");
}, function (_a) {
    var $noBorder = _a.$noBorder;
    return $noBorder && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n            border-bottom: none;\n        "], ["\n            border-bottom: none;\n        "])));
}, Icon, Variables.Transitions.Short, function (_a) {
    var $isOpen = _a.$isOpen, $icon = _a.$icon;
    return $isOpen && css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n                transform: rotate(", "deg);\n            "], ["\n                transform: rotate(", "deg);\n            "])), $icon === "chevron" ? 180 : 45);
});
/*==================== Component ====================*/
var AccordionItem = function (_a) {
    var _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, _c = _a.icon, icon = _c === void 0 ? "plus" : _c, title = _a.title, content = _a.content, _d = _a.$accordionStyle, $accordionStyle = _d === void 0 ? "basic" : _d, $noBorder = _a.$noBorder;
    var _e = useState(isOpen), open = _e[0], setOpen = _e[1];
    return (React.createElement(Item, null,
        React.createElement(Button, { onClick: function () { return setOpen(!open); }, "$isOpen": open, "$icon": icon, "$accordionStyle": $accordionStyle, "$noBorder": $noBorder },
            title,
            React.createElement(Icon, { name: icon === "chevron" ? "chevron-down-solid" : "plus-solid", size: 16 })),
        React.createElement(Content, { as: typeof content === "string" ? P : "div", "$isOpen": open, "$accordionStyle": $accordionStyle }, content)));
};
var Accordion = function (_a) {
    var _b = _a.accordionStyle, accordionStyle = _b === void 0 ? "basic" : _b, _c = _a.icon, icon = _c === void 0 ? "plus" : _c, items = _a.items, props = __rest(_a, ["accordionStyle", "icon", "items"]);
    return (React.createElement(Container, __assign({ "$accordionStyle": accordionStyle }, props), items.map(function (item, i) { return (React.createElement(AccordionItem, { icon: icon, isOpen: item.isOpen, title: item.title, content: item.content, "$accordionStyle": accordionStyle, "$noBorder": accordionStyle === "rounded" && i === items.length - 1 && true, key: uuid() })); })));
};
export default Accordion;
/*==================== Types ====================*/
var accordionStyle = {
    basic: "basic",
    rounded: "rounded",
};
var icons = {
    plus: "plus",
    chevron: "chevron",
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
